<template>
  <v-container fill-height grid-list-lg wrap>
    <v-layout align-start justify-center px-5 pb-5 wrap>
      <v-flex :class="pageSize">
        <span class="headline" style="margin-left: -8px">{{ title }}</span>
        <p
          class="title body-1 disabled--text"
          style="margin-left: -8px; margin-top: 5px">
          {{ description }}
        </p>
        <lister
          style="height: 100%"
          :items="items"
          :cardBreakpoints="cardBreakpoints"
          :searchPlaceholder="searchPlaceholder"
          :autosort="false"
          :hideSearchbar="hideSearchbar"
          :emptyListMessage="emptyListMessage"
        >
          <template v-slot:default="slotProps">
            <slot name="content" :item="slotProps.item" :index="slotProps.index"></slot>
          </template>
        </lister>
      </v-flex>
      <slot name="dialog"></slot>
    </v-layout>
  </v-container>
</template>

<script>
import Lister from '@/components/Lister.vue';

export default {
  components: { Lister },
  props: {
    title: String,
    description: String,
    searchPlaceholder: String,
    pageSize: { type: String, default: 'lg8 sm10 xs12 px-4' },
    cardBreakpoints: { type: String, default: 'xs12 md6' },
    emptyListMessage: { type: String, default: 'Nenhum item cadastrado...' },
    hideSearchbar: { type: Boolean, default: false },
    items: Array,
  },
};
</script>

<style scoped>
  .title {
    text-align: justify;
    margin-left: -8px;
  }
  .description {
  margin-left: -5px;
  margin-top: 5px;
  }
</style>
